import type { FC, ReactNode } from 'react'

import { Link } from 'react-router-dom'

interface LinkAdapterProps {
  href: string
  children: ReactNode
  [key: string]: unknown
}

const LinkAdapter: FC<LinkAdapterProps> = ({ href, children, ...props }) => (
  <Link to={href} {...props}>
    {children}
  </Link>
)

const createLinkAdapter = () => LinkAdapter

export default createLinkAdapter
